import { jsx as _jsx } from 'react/jsx-runtime';
export const IconFlashOn = (props) =>
  _jsx('svg', {
    viewBox: '0 0 24 24',
    fill: 'none',
    ...props,
    children: _jsx('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7 4a1 1 0 0 1 1-1h8a1 1 0 0 1 .92 1.394L14.515 10l-1.838-.788L14.483 5H9v8h1a2 2 0 0 1 2 2v1.764l2.384-4.768a2 2 0 0 1-1.706-2.784l1.838.788H16a1 1 0 0 1 .894 1.447l-5 10A1 1 0 0 1 10 21v-6H8a1 1 0 0 1-1-1V4Z',
      fill: 'currentColor',
    }),
  });
IconFlashOn.displayName = 'IconFlashOn';
